import Box from '@/common/components/Box'
import Skeleton from '@/common/components/Skeleton'

const MaintenanceWorkflowForwardingShowLoading = () => {
  return (
    <div className="flex-1 overflow-hidden flex flex-col gap-4">
      <Box className="p-4 flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <Skeleton className="bg-white-100 h-7 w-44" />

          <Skeleton className="bg-white-100 h-10 w-48" />
        </div>

        <div className="flex gap-3">
          <div className="flex flex-col gap-1">
            <Skeleton className="bg-white-100 h-4 w-36" />

            <Skeleton className="bg-white-100 h-4 w-24" />
          </div>
        </div>
      </Box>

      <Box className="p-4 flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <Skeleton className="bg-white-100 h-7 w-[414px]" />

          <div className="flex gap-3">
            <Skeleton className="bg-white-100 h-10 w-24" />

            <Skeleton className="bg-white-100 h-10 w-24" />
          </div>
        </div>

        <div className="flex gap-3">
          <div className="flex flex-col gap-1">
            <Skeleton className="bg-white-100 h-4 w-36" />

            <div className="flex items-center gap-1">
              <Skeleton className="bg-white-100 rounded-full size-5" />

              <Skeleton className="bg-white-100 h-4 w-36" />
            </div>
          </div>
        </div>

        <Box className="p-4 flex flex-col gap-4">
          <Skeleton className="bg-white-100 w-36 h-7" />

          <div className="flex flex-col gap-3">
            <div className="flex gap-3">
              <div className="flex flex-col gap-1">
                <Skeleton className="bg-white-100 h-4 w-28" />

                <Skeleton className="bg-white-100 h-4 w-36" />
              </div>
            </div>

            <div className="flex gap-3">
              <div className="flex flex-col gap-1">
                <Skeleton className="bg-white-100 h-4 w-32" />

                <Skeleton className="bg-white-100 h-4 w-36" />
              </div>

              <div className="flex flex-col gap-1">
                <Skeleton className="bg-white-100 h-4 w-40" />

                <Skeleton className="bg-white-100 h-4 w-32" />
              </div>
            </div>
          </div>
        </Box>
      </Box>
    </div>
  )
}

export default MaintenanceWorkflowForwardingShowLoading
